import React from "react";
import { CmsImage } from "../types/cms";

type ImageProps = CmsImage & {
  onDark?: boolean;
};

const Image = ({
  heading,
  image,
  alt,
  caption,
  onDark = false,
}: ImageProps) => {
  return (
    <div>
      <h1>{heading}</h1>
      <img src={image} alt={alt} style={{ borderRadius: "10px" }} />
      <p>{caption}</p>
    </div>
  );
};

export default Image;
